import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Map,
  useMap,
  // eslint-disable-next-line
} from '@vis.gl/react-google-maps/dist/index.umd.js'
import MissingLotMarker from './components/MissingLotMarker/MissingLotMarker'
import ParkingButtonPanel from './components/ParkingButtonPanel/ParkingButtonPanel'
import StopsTwo from './components/Stops/StopsTwo'
import { setMapInstance, setZoom, updateLatLng } from './redux/myMapsSlice'
import { mapDarkStyles, mapLightStyles } from '../../utils/helpers'
import BottomSheet from '../../components/BottomSheets/BottomSheet'
import useMyMapStyles from '../../MyMapStyles'
import { TabPanel } from '../../../dashboard/DashboardComponents/TabPanel/TabPanel'
import VehicleRouteTwo from '../Vehicles/components/VehicleRoute/VehicleRouteTwo'
import VehiclesTwo from '../Vehicles/VehiclesTwo'
import { selectDarkMode } from '../../../settings/settingsSlice'
import BuildingStopsTwo from './components/BuildingStops/BuildingStopsTwo'
import MapInfoWindow from './components/MapInfoWindow/MapInfoWindow'
import PolylineFromDataset from './components/PolylineFromDataset/PolylineFromDataset'
// import BuildingPolygon from './components/PolylineFromDataset/BuildingPolygon'
import CheckIsMobile from '../../../../../utils/isMobileHook'
import {
  MOBILEPARKINGINFOWINDOW,
  ROUTE,
  ROUTES,
  SEARCH,
  VEHICLE,
} from '../../utils/constants'

const MyMap = ({ disableDefaultUI = false }) => {
  const map = useMap()
  const classes = useMyMapStyles()
  const dispatch = useDispatch()
  const { lat, lng, zoom, tabValue, parkingLotData, bottomSheet } = useSelector(
    (s) => s.maps,
  )
  const { drawerIsOpen } = useSelector((state) => state.navigation)
  const darkMode = useSelector(selectDarkMode)
  const isMobile = CheckIsMobile()
  const [latitude, setLatitude] = React.useState(40.51868)
  const [longitude, setLongitude] = React.useState(-74.46147)
  const [showMissingParkingLots, updateShowMissingParkingLots] =
    React.useState(false)
  const [showParkingLots, updateShowParkingLots] = React.useState(true)
  const [showBusStops, updateShowBusStops] = React.useState(true)
  const dragging = React.useRef(false)

  const bottomSheets = [SEARCH, ROUTES, ROUTE, VEHICLE, MOBILEPARKINGINFOWINDOW]
  const isMobileWithoutBottomNav =
    bottomSheets.includes(bottomSheet.component) && isMobile

  React.useEffect(() => {
    if (lat !== latitude && lng !== longitude) {
      setLatitude(lat)
      setLongitude(lng)
      dispatch(
        updateLatLng({
          lat,
          lng,
          zoom,
        }),
      )
    }
  }, [lat, lng, zoom])

  const handleMouseChange = (camera) => {
    setLatitude(camera.map.center.lat())
    setLongitude(camera.map.center.lng())
    if (dragging.current) {
      dispatch(
        updateLatLng({
          lat: camera.map.center.lat(),
          lng: camera.map.center.lng(),
          zoom: camera.map.zoom,
        }),
      )
    }
  }
  const getMapStyles = (customClasses) => {
    if (!drawerIsOpen) {
      if (isMobileWithoutBottomNav) {
        return customClasses.mapContainerMobilePage
      }
      return customClasses.mapContainer
    }
    return customClasses.mapContainerNavOpen
  }

  React.useEffect(() => {
    if (map) {
      dispatch(setMapInstance(map))
    }
  }, [map])
  return (
    <TabPanel value={tabValue} index={0}>
      <MapInfoWindow dispatch={dispatch} isMobile={isMobile} />
      <Map
        mapId="2b3f87ff16688c1e"
        className={getMapStyles(classes)}
        defaultCenter={{ lat: 40.50045704434057, lng: -74.44818987833548 }}
        onCenterChanged={handleMouseChange}
        defaultZoom={14}
        zoom={zoom}
        onDragstart={() => {
          dragging.current = false
        }}
        onDragend={() => {
          dragging.current = false
        }}
        onZoomChanged={(newZoom) => {
          if (newZoom?.detail?.zoom) {
            dispatch(setZoom(newZoom.detail.zoom))
          }
        }}
        gestureHandling="greedy"
        disableDefaultUI
        options={{
          zoomControl: true,
          zoomControlOptions: { position: 7 },
          streetViewControl: true,
          mapTypeControl: true,
          fullscreenControl: true,
          styles: darkMode ? mapDarkStyles : mapLightStyles,
          streetViewControlOptions: { position: 6 },
          disableDefaultUI,
          rotateControl: false,
          tilt: 0,
        }}
      >
        <ParkingButtonPanel
          updateShowParkingLots={updateShowParkingLots}
          updateShowMissingParkingLots={updateShowMissingParkingLots}
          showParkingLots={showParkingLots}
          showMissingParkingLots={showMissingParkingLots}
          showBusStops={showBusStops}
          updateShowBusStops={updateShowBusStops}
          isMobileWithoutBottomNav={isMobileWithoutBottomNav}
        />
        <PolylineFromDataset
          showParkingLots={showParkingLots}
          dispatch={dispatch}
          parkingLotData={parkingLotData}
          isMobile={isMobile}
        />
        {showMissingParkingLots ? (
          <MissingLotMarker
            latitude={latitude}
            longitude={longitude}
            dispatch={dispatch}
            zoom={zoom}
          />
        ) : null}
        {showBusStops ? <StopsTwo map={map} /> : null}
        <BuildingStopsTwo />
        <VehicleRouteTwo />
        <VehiclesTwo />
        {/* <BuildingPolygon /> */}
        <BottomSheet />
      </Map>
    </TabPanel>
  )
}
export default MyMap
